/**
 * Jurisdiction overlays — resolved on the backend from Organizations.state.
 * GET /client/ir/overlays/ returns { state, resolved_key, overlay }.
 */
import api from "../../../helpers/axios";

let cache = null;

/**
 * Resolved overlay for the caller's organization.
 * Pass `{ force: true }` after org State changes so OH→OTRP is not stuck on a
 * previously cached generic overlay.
 */
export async function fetchJurisdictionOverlay(options = {}) {
  const force = Boolean(options.force);
  if (!force && cache) return cache;
  const res = await api.get("/client/ir/overlays/");
  cache = res?.data?.data || null;
  return cache;
}

/** Clear cache (e.g. after org profile State is saved). */
export function clearOverlayCache() {
  cache = null;
}
